import React from 'react';
import { useBoardState } from '../../context/BoardContext';
import { Header, OperationStatusIndicator } from '../Common';
import { KanbanBoard } from './';
import { TaskContainer } from '../Task';

const BoardContent = () => {
  const { operationStatus } = useBoardState();

  return (
    <div className="task-board jira-board-app">
      <Header />
      <KanbanBoard />
      <TaskContainer />
      <OperationStatusIndicator operationStatus={operationStatus} />
    </div>
  );
};

export default React.memo(BoardContent);
